// extracted by mini-css-extract-plugin
module.exports = {"input":"searchInput_input__23iSU"};